<template lang="pug">
#stakeholder
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.custom_container_lg.i_mt_14.i_mt_md_10.position-relative
    .desc.i_mt_14.i_mt_md_10
      .text-center.text-lg-left
        h2.title.bottom_line {{ stakeholder.area01_Title }}
      p.i_mt_8(v-html="stakeholder.area01_Content")
    .desc.i_mt_14.i_mt_md_10
      h2.title.text-center.text-lg-left {{ stakeholder.area02_Title }}
    .stakeholder_table.unexpand(v-if="!isExpand")
      table.fade.table.table-bordered.i_mt_8
        thead
          tr
            th.col_1(scope="col") 利害關係人
            th.col_2(scope="col") 關切議題
            th.col_3(scope="col") 關切議題推動方針
            th.col_4(scope="col") 溝通管道（頻率）
        tbody
          tr
            td.col_1.stakeholder_col
              p {{ stakeholder.area02_IssueList[0].Role }}
              img(:src="stakeholder.area02_IssueList[0].Icon")
            td.col_2
              p(v-html="stakeholder.area02_IssueList[0].Issue")
    .table_wrapper.i_mt_8(v-if="isExpand")
      .stakeholder_table(@scroll="scrollEvent")
        table.fade.table.table-bordered
          thead
            tr
              th.col_1(scope="col") 利害關係人
              th.col_2(scope="col") 關切議題
              th.col_3(scope="col") 關切議題推動方針
              th.col_4(scope="col") 溝通管道（頻率）
          tbody
            tr(
              v-for="(stakeholder, index) in stakeholder.area02_IssueList",
              :key="index"
            )
              td.col_1.stakeholder_col
                p {{ stakeholder.Role }}
                img(:src="stakeholder.Icon")
              td.col_2 
                p(v-html="stakeholder.Issue")
              td.col_3
                p(v-html="stakeholder.Policy")
              td.col_4 
                div(
                  v-for="(Communication, communicationIndex) in stakeholder.CommunicationList",
                  :key="communicationIndex"
                )
                  a(
                    v-if="Communication.CommunicationURL",
                    :href="Communication.CommunicationURL",
                    :style="{ color: '#029CE6' }"
                  ) {{ Communication.CommunicationTitle }}
                  li(v-else="", , :style="{ color: '#25282b' }") {{ Communication.CommunicationTitle }}
      .scroll_sign.left.d-md-none(v-if="scrollLeftSide")
      .scroll_sign.right.d-md-none(v-if="scrollRightSide")
    .cover_gradient.d-md-none(v-if="!isExpand")
      .btn_round.btn_blue_ci(@click="expand") 展開表格
</template>

<script>
import { getStakeholder } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsSocialResponsibilityStakeholder",
  metaInfo() {
    return {
      title: this.stakeholder.SEO_Title,
      meta: [{ name: "description", content: this.stakeholder.SEO_Description }],
    };
  },
  components: {
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      isExpand: false,
      scrollLeftSide: false,
      scrollRightSide: true,
      stakeholder: {},
    };
  },
  watch: {
    "$store.state.screenWidth": function (width) {
      if (width > 767) {
        this.isExpand = true;
      }
    },
  },
  created() {
    this.onResize();
    this.getStakeholder();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };

      if (thiz.$store.state.screenWidth > 767) {
        this.isExpand = true;
      }
    },
    expand() {
      this.isExpand = true;
    },
    getStakeholder() {
      getStakeholder().then((response) => {
        this.stakeholder = response.data;
      });
    },
    scrollEvent(e) {
      if (e.srcElement.scrollLeft == 0) {
        this.scrollLeftSide = false;
      } else {
        this.scrollLeftSide = true;
      }

      if (
        Math.ceil(e.srcElement.scrollLeft) + e.srcElement.offsetWidth >=
        e.srcElement.scrollWidth
      ) {
        this.scrollRightSide = false;
      } else {
        this.scrollRightSide = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/about_us";
@import "@/assets/style/about_us/news";
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/stakeholder";
</style>
